import { themeNames } from '@fluentui/react-teams';
import React from 'react';
import DarkDatabaseSVG from '../../../../../svg/fileTypes/dark/Database.svg';
import DarkDocumentManagementSVG from '../../../../../svg/fileTypes/dark/DocumentManagement.svg';
import DarkExcelDocumentSVG from '../../../../../svg/fileTypes/dark/ExcelDocument.svg';
import DarkFileBugSVG from '../../../../../svg/fileTypes/dark/FileBug.svg';
import DarkFileCodeSVG from '../../../../../svg/fileTypes/dark/FileCode.svg';
import DarkFilePDBSVG from '../../../../../svg/fileTypes/dark/FilePDB.svg';
import DarkFileSQLSVG from '../../../../../svg/fileTypes/dark/FileSQL.svg';
import DarkMailSVG from '../../../../../svg/fileTypes/dark/Mail.svg';
import DarkPageSVG from '../../../../../svg/fileTypes/dark/Page.svg';
import DarkPDFSVG from '../../../../../svg/fileTypes/dark/PDF.svg';
import DarkPhoto2SVG from '../../../../../svg/fileTypes/dark/Photo2.svg';
import DarkPowerPointDocumentSVG from '../../../../../svg/fileTypes/dark/PowerPointDocument.svg';
import DarkSlideshowSVG from '../../../../../svg/fileTypes/dark/Slideshow.svg';
import DarkTextDocumentSVG from '../../../../../svg/fileTypes/dark/TextDocument.svg';
import DarkWordDocumentSVG from '../../../../../svg/fileTypes/dark/WordDocument.svg';
import DarkZipFolderSVG from '../../../../../svg/fileTypes/dark/ZipFolder.svg';
import DatabaseSVG from '../../../../../svg/fileTypes/light/Database.svg';
import DocumentManagementSVG from '../../../../../svg/fileTypes/light/DocumentManagement.svg';
import ExcelDocumentSVG from '../../../../../svg/fileTypes/light/ExcelDocument.svg';
import FileBugSVG from '../../../../../svg/fileTypes/light/FileBug.svg';
import FileCodeSVG from '../../../../../svg/fileTypes/light/FileCode.svg';
import FilePDBSVG from '../../../../../svg/fileTypes/light/FilePDB.svg';
import FileSQLSVG from '../../../../../svg/fileTypes/light/FileSQL.svg';
import MailSVG from '../../../../../svg/fileTypes/light/Mail.svg';
import PageSVG from '../../../../../svg/fileTypes/light/Page.svg';
import PDFSVG from '../../../../../svg/fileTypes/light/PDF.svg';
import Photo2SVG from '../../../../../svg/fileTypes/light/Photo2.svg';
import PowerPointDocumentSVG from '../../../../../svg/fileTypes/light/PowerPointDocument.svg';
import SlideshowSVG from '../../../../../svg/fileTypes/light/Slideshow.svg';
import TextDocumentSVG from '../../../../../svg/fileTypes/light/TextDocument.svg';
import WordDocumentSVG from '../../../../../svg/fileTypes/light/WordDocument.svg';
import ZipFolderSVG from '../../../../../svg/fileTypes/light/ZipFolder.svg';

const iconProperties = { width: '20px', height: '20px' }

const iconByFileExtension: { name: string, types: string, element: JSX.Element, darkElement: JSX.Element }[] = [
  { name: "Page", types: "unknown", element: <PageSVG {...iconProperties} />, darkElement: <DarkPageSVG {...iconProperties} /> },
  { name: "FileBug", types: "failed", element: <FileBugSVG {...iconProperties} />, darkElement: <DarkFileBugSVG {...iconProperties} /> },
  { name: "Photo2", types: "jpg gif png jpeg bmp ico tif tiff psd ps ai", element: <Photo2SVG {...iconProperties} />, darkElement: <DarkPhoto2SVG {...iconProperties} /> },
  { name: "WordDocument", types: "doc docm docx odt wpd", element: <WordDocumentSVG {...iconProperties} />, darkElement: <DarkWordDocumentSVG {...iconProperties} /> },
  { name: "TextDocument", types: "txt rtf", element: <TextDocumentSVG {...iconProperties} />, darkElement: <DarkTextDocumentSVG {...iconProperties} /> },
  { name: "ExcelDocument", types: "xls xlsm xlsx ods csv", element: <ExcelDocumentSVG {...iconProperties} />, darkElement: <DarkExcelDocumentSVG {...iconProperties} /> },
  { name: "PowerPointDocument", types: "key pps ppt pptx odp", element: <PowerPointDocumentSVG {...iconProperties} />, darkElement: <DarkPowerPointDocumentSVG {...iconProperties} /> },
  { name: "ZipFolder", types: "zip rar pkg 7z deb arj", element: <ZipFolderSVG {...iconProperties} />, darkElement: <DarkZipFolderSVG {...iconProperties} /> },
  { name: "PDF", types: "pdf", element: <PDFSVG {...iconProperties} />, darkElement: <DarkPDFSVG {...iconProperties} /> },
  { name: "FileSQL", types: "sql", element: <FileSQLSVG {...iconProperties} />, darkElement: <DarkFileSQLSVG {...iconProperties} /> },
  { name: "Database", types: "dat db dbf mdb accdb", element: <DatabaseSVG {...iconProperties} />, darkElement: <DarkDatabaseSVG {...iconProperties} /> },
  { name: "Mail", types: "email  eml emlx msg oft ost pst vcf", element: <MailSVG {...iconProperties} />, darkElement: <DarkMailSVG {...iconProperties} /> },
  { name: "FilePDB", types: "bat bin exe apk wsf jar ps1 tar", element: <FilePDBSVG {...iconProperties} />, darkElement: <DarkFilePDBSVG {...iconProperties} /> },
  { name: "DocumentManagement", types: "bat bin exe apk wsf jar ps1 tar", element: <DocumentManagementSVG {...iconProperties} />, darkElement: <DarkDocumentManagementSVG {...iconProperties} /> },
  { name: "FileCode", types: "json xml class cs js css less tsx html htm xhtml asp aspx", element: <FileCodeSVG {...iconProperties} />, darkElement: <DarkFileCodeSVG {...iconProperties} /> },
  { name: "Slideshow", types: "avi flv m4v mkv mov mp4 mpg mpeg wmv", element: <SlideshowSVG {...iconProperties} />, darkElement: <DarkSlideshowSVG {...iconProperties} /> },
]

type FileTypeIcon = typeof iconByFileExtension[0];

export const PHOTO_ICON_NAME = "Photo2";

const unknownIcon = iconByFileExtension[0];
const photoIcon = iconByFileExtension.find(icon => icon.name === PHOTO_ICON_NAME) ?? unknownIcon;

export const iconElementFor = (icon: FileTypeIcon, theme: any) =>
  (theme?.siteVariables?.theme === themeNames.Dark) ? icon.darkElement : icon.element;

// FileExtension is a computed getter on the backend model with no mapped column, so it is
// absent from the OData EDM and never reaches us - anything loaded through
// Action.GetTicketAttachments arrives without one. Fall back to the file name.
export const resolveDocType = (ext: string, file?: any) => {
  const source = ext || file?.FileName || file?.name || "";
  return source.substring(source.lastIndexOf(".") + 1).toLowerCase();
}

export const findIcon = (docType: string) => {
  if (!docType) return unknownIcon;
  return iconByFileExtension.find(icon => icon.types.split(/\s+/).includes(docType)) ?? unknownIcon;
}

export const getFileIconName = (ext: string, file?: any) => findIcon(resolveDocType(ext, file)).name;

export const isImageFile = (ext: string, file?: any) => getFileIconName(ext, file) === PHOTO_ICON_NAME;

export const getPhotoIconElement = (theme: any) => iconElementFor(photoIcon, theme);
